<template>
  <page-option :disable-add="!checkAccess('rasterType.create')" overflow-hidden>
    <template #title>
      <v-avatar color="#E3FCF7" size="35">
        <v-icon color="#108F6E">mdi-satellite-variant</v-icon>
      </v-avatar>
      <div class="pl-2 title-page">{{ $t('sidebar.raster-type.name') }}</div>
    </template>
    <template #below-toolbar>
      <FilterSearch
        v-model="params"
        :disableCreate="!checkAccess('rasterType.create')"
        placeholder="Tìm kiếm theo mã, tên, mô tả"
        @click:create="onCreateItem()"
      >
      </FilterSearch>
    </template>
    <v-sheet class="fillheight overflow-hidden">
      <base-serve-table
        ref="table"
        :api="api"
        :headers="headers"
        :params="params"
        :defaultParams="default_params"
      >
        <template v-slot:[`item.updated_at`]="{ item }">
          <span>{{ item.updated_at | dateTime('short') }}</span>
        </template>
        <template v-slot:[`item.created_at`]="{ item }">
          <span>{{ item.created_at | dateTime('short') }}</span>
        </template>
        <template v-slot:[`item.action`]="{ item }">
          <base-button-group
            class="full-width"
            :items="menus"
            :value="item"
          ></base-button-group>
        </template>
      </base-serve-table>
    </v-sheet>
    <RasterTypeDialog ref="dialog" @reset="onReset" />
  </page-option>
</template>

<script>
import FilterSearch from '@layouts/filter-search.vue'
import { API_RASTER_TYPE } from '@api'
import { ConfirmBuilder } from '@utils'
import { EDIT_TYPE } from '@constant'
import RasterTypeDialog from './raster-type-dialog.vue'

export default {
  components: {
    FilterSearch,
    RasterTypeDialog,
  },
  data: (vm) => ({
    default_params: {},
    params: { search: '' },
    menus: [
      {
        type: 'update',
        handler: (item) => vm.onUpdateItem(item),
        disabled: (item) => !vm.checkAccess('rasterType.update', item),
      },
      {
        type: 'delete',
        handler: (item) => vm.onDeleteItem(item),
        disabled: (item) => !vm.checkAccess('rasterType.delete', item),
      },
    ],
    headers: [
      {
        text: 'Mã',
        align: 'start',
        sortable: true,
        value: 'code',
        width: 160,
      },
      {
        text: 'Tên hiển thị',
        align: 'start',
        sortable: true,
        value: 'name',
      },
      {
        text: 'Mô tả',
        align: 'start',
        sortable: false,
        value: 'description',
      },
      {
        text: 'Ngày tạo',
        align: 'start',
        sortable: true,
        value: 'created_at',
        width: 170,
      },
      {
        text: 'Ngày cập nhật',
        align: 'start',
        sortable: true,
        value: 'updated_at',
        width: 170,
      },
      {
        trans: 'field.action',
        value: 'action',
        sortable: false,
        width: '150px',
        align: 'center',
      },
    ],
  }),
  computed: {
    api() {
      return API_RASTER_TYPE
    },
  },
  methods: {
    async onDeleteItem(item) {
      let confirm = new ConfirmBuilder()
      confirm
        .addMessage('confirm.delete-name')
        .setTitle('confirm.title')
        .setOption({
          params: { name: item.name },
          color: 'error',
        })
        .setType('delete')
      if (await confirm.confirm()) {
        const result = await API_RASTER_TYPE.destroy(item.id, item)
        if (result.isDone) {
          this.onReset()
        }
        return result
      }
    },
    onCreateItem() {
      this.$refs.dialog.open({}, EDIT_TYPE.CREATE)
    },
    onUpdateItem(item) {
      this.$refs.dialog.open(item, EDIT_TYPE.UPDATE)
    },
    onReset() {
      this.$refs.table.reload()
    },
  },
}
</script>
